import { render, staticRenderFns } from "./topic-list.vue?vue&type=template&id=47db2311&lang=html&"
import script from "./topic-list.vue?vue&type=script&lang=js&"
export * from "./topic-list.vue?vue&type=script&lang=js&"
import style0 from "./topic-list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports